/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    UpdateRolePermissionRelationDto,
    UpdateRolePermissionRelationDtoFromJSON,
    UpdateRolePermissionRelationDtoFromJSONTyped,
    UpdateRolePermissionRelationDtoToJSON,
} from './';

/**
 * 
 * @export
 * @interface UpdateRolePermissionRelationsCommand
 */
export interface UpdateRolePermissionRelationsCommand {
    /**
     * 
     * @type {Array<UpdateRolePermissionRelationDto>}
     * @memberof UpdateRolePermissionRelationsCommand
     */
    rolePermissionRelations: Array<UpdateRolePermissionRelationDto>;
}

export function UpdateRolePermissionRelationsCommandFromJSON(json: any): UpdateRolePermissionRelationsCommand {
    return UpdateRolePermissionRelationsCommandFromJSONTyped(json, false);
}

export function UpdateRolePermissionRelationsCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateRolePermissionRelationsCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'rolePermissionRelations': ((json['rolePermissionRelations'] as Array<any>).map(UpdateRolePermissionRelationDtoFromJSON)),
    };
}

export function UpdateRolePermissionRelationsCommandToJSON(value?: UpdateRolePermissionRelationsCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'rolePermissionRelations': ((value.rolePermissionRelations as Array<any>).map(UpdateRolePermissionRelationDtoToJSON)),
    };
}


